import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import React, { Fragment, useState, useEffect } from 'react';
import axios from 'axios';

import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Box,
  makeStyles
} from '@material-ui/core';
import StatusDataContext from '../../contexts/StatusDataContext';
import Header from '../headers/Header';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import { useLocation, useParams } from 'react-router-dom';
import RepairsDetailed from './tables/RepairsDetailed';
import Charts from './charts/Charts';
import Schema from './vacuumBag/Schema';
import MaterialTable from 'material-table';
import TableGenerator from './TableGenerator'
import Information from './information/Informations';
import ThermocouplesConfig from './ThermocouplesConfig';
import PdfReader from './dataUploader/PdfReader';
import ImageUploader from './dataUploader/ImageUploader';
import GeneratedReport from '../report/GeneratedReport';
import Footer from '../footer/Footer';
import Identification from './identification/Identification';
var information = new Array(5);

const useRowStyles = makeStyles({
    root: {
      '& > *': {
        borderBottom: 'unset',
      },
    },
  });
  
  function TabPanel(props) {
   
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };



const TabsDivider = ({ className, ...rest }) => {
  var [listEvents, setListEvents] = React.useState([]);
  const { uuid } = useParams();
  const location = useLocation();

  useEffect(() => {
    
    if(location.state.typeAnita[1].length>30) {
      var verif = false ;
      var myList=[]
      var myListTcs=[]
      var myListBlankets=[]
      var currentIndex = "0" ;
      location.state.typeAnita[1].map((x,index)=>{

        if( verif && x!=="Thermocouple S/N" && x!=="Thermocouples S/N" && x!==""){
          var obj={}
         var  currentX = x.split('-')
         console.error(currentX)
         obj.id=Math.floor(Math.random() * 10000)
          obj.time=currentX[0];
          obj.event=currentX[1];
          myList.push(obj)
        } else if (x==="Thermocouple S/N" || x==="Thermocouples S/N" ) {
          verif=false;
          currentIndex="thermocouple";
        }
        else if (x==="Curing cycle Alarm and Event" || x==="Curing cycle Alarms and Events"  ) {
          verif=true;
          currentIndex="Events";
        }
        else if (x==="Blanket S/N" || x==="Blankets S/N"  ) {
          verif=false;
          currentIndex="Blanket";
        }
        else if(currentIndex==="Blanket" && x!== "" ){
          var obj = {}
          obj.pn =x
          obj.zid=x
          myListBlankets.push(obj)
        }
        else if(currentIndex==="thermocouple"){
          var obj = {}
          obj.pn =x
          obj.zid=x
          myListTcs.push(obj)
        }

      })
      setListEvents(myList)
      setTapisThermocouple(myListTcs)
      setMatUsed(myListBlankets)
    }
      else console.log('no events')

      console.log(currentIndex+" "+location.state.typeAnita[1][currentIndex])
 }, [location]);
  
    var [comm, setComm] = React.useState("");
  const [value, setValue] = React.useState(0);
  const [imgSource, setImgSource] = React.useState("-1");
  
  var [myimagelist,setMyimagelist] = React.useState([]);
  var [vacuumImage,setVacuumImage] = React.useState([]);
  var [themoImages,setThemoImages] = React.useState([]);
  var [additionalElementsPictures,setAdditionalElementsPictures] = React.useState([]);
  var [oeuvreImages,setOeuvreImages] = React.useState([]);
  var [tapisThermocouple,setTapisThermocouple] = React.useState([]);
  var [matUsed,setMatUsed] = React.useState([]);
  var [additionalElements,setAdditionalElements] = React.useState([]);
  var [remarks, setRemarks] = React.useState(["F - Filler ply", "E - Extra ply", "Sa - Sanding ply", "St - Structural ply", "E - Extra ply", "Sa - Sanding ply", "St - Structural ply", "St - Structural ply","F - Filler ply", "E - Extra ply", "Sa - Sanding ply", "St - Structural ply", "E - Extra ply", "Sa - Sanding ply", "St - Structural ply", "St - Structural ply"]);
  const [entete, setEntete] = React.useState(["Company", "Defect - Techlog Ref Number", "Customer Code", "A/C Type", "MSN", "A/C Registration", "Notes", "Part Number", "Serial Number", "Wide", "Length", "Depth", "Position", "Other", "", "", "", "", "", "", "", "", "", "", "", "", "", ""]);
  const [chartCalledFrom, setChartCalledFrom] = React.useState(0);
  const [activeDesc, setActiveDesc] = React.useState(0);
  const [description, setDescription] = React.useState("");
  const [numberplies, setNumberplies] = React.useState(0);
  const [activeCircle, setActiveCircle] = React.useState(0);
  const [angles, setAngles] = React.useState([]);
  const [calculatedangles, setCalculatedangles] = React.useState([]);
  const [open, toggleOpen] = React.useState(false);
  const [remarksAuto, setRemarksAuto] = React.useState([{ label: 'F - Filler ply' },{ label: 'St - Structural ply' },  { label: 'E - Extra ply' },{ label: 'Sa - Sanding ply' },{ label: '12 Angry Men' }]);
var [descriptionCourbe, setDescriptionCourbe] = useState("");

  const [dialogValue, setDialogValue] = React.useState({
    title: ''
  });

  const [optionsVacuumDiagram,setOptionsVacuumDiagram] = useState([
    { value: 'Peel Ply', label: 'Peel Ply', color:'#D2691E' },
    { value: 'Perforated nylon', label: 'Perforated nylon', color:'#00FFFF' },
    { value: 'Bleeder Ply', label: 'Bleeder Ply', color:'Black' },
    { value: 'Non Perforated nylon', label: 'Non Perforated nylon', color:'#87CEEB'},
    { value: 'Flexible caul plate Sheet 1.4m width', label: 'Flexible caul plate Sheet 1.4m width', color:'#F5F5DC'},
    { value: 'Heating Blanket', label: 'Heating Blanket', color:'#a4181b'},
    { value: 'Flexible Insulator', label: 'Flexible Insulator', color:'#AC9362'},
    { value: 'Airweave - Breather', label: 'Airweave - Breather', color:'#00008B'},

    { value: 'Vacuum bag nylon', label: 'Vacuum bag nylon', color:'#FFD700' },
    { value: 'Vacuum bag tape', label: 'Vacuum bag tape', color:'#DAA520' },

    { value: 'Release Fabric', label: 'Release Fabric', color:'#FAEBD7' },
    { value: 'Bleeder Fabric', label: 'Bleeder Fabric', color:'#7FFFD4' },
    { value: 'Insulator Sheet flexible 1.4 m width', label: 'Insulator Sheet flexible 1.4 m width', color:'#0000FF'},
   
    { value: 'Glass fiber', label: 'Glass fiber', color:'#A9A9A9' },
    { value: 'Carbon fiber', label: 'Carbon fiber', color:'#8B008B' },
    { value: 'Metallisation fabrics', label: 'Metallisation fabrics', color:'#A52A2A' },
    { value: 'Thermal insulation', label: 'Thermal insulation', color:'#008000' },
    { value: 'Adhesive films', label: 'Adhesive films', color:'#228B22' },
    { value: 'Foaming adhesives', label: 'Foaming adhesives', color:'#4363d8' },
    { value: 'Honeycomb panels', label: 'Honeycomb panels', color:'#FF8C00' },
    { value: 'Moulding products', label: 'Moulding products', color:'#5F9EA0' },
    { value: 'High temperature tape', label: 'High temperature tape',color:'#7FFF00' }
  ])
  
  const handleClose = () => {
    setDialogValue({
      title: ''
    });

    toggleOpen(false);
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  /*
  <Tab label="Documentation imagée de la réparation" />.



  <TabPanel value={value} index={4}>
        
      <Information></Information><br/>
      <PdfReader></PdfReader>
       </TabPanel>


<ImageUploader myimagelist={oeuvreImages} setMyimagelist={setOeuvreImages} ></ImageUploader>

  */
 
  return (
    <Fragment>
        <Header type={"client"} title={"Graphs"}  />
          <AppBar position="relative" style={{
    width: '100%', margin:'auto'
  }}>
        <Tabs value={value}  variant="scrollable"
  scrollButtons="auto"
         onChange={handleChange} aria-label="simple tabs example">
          <Tab label="Identification" />
          <Tab label="Charts" />
          <Tab label="Tables"  />
          <Tab label="Event " />
          <Tab label="Vacuum Bagging Layer configuration" />
          <Tab label="Additionnal elements " />
          <Tab label="Annex" />
          <Tab label="Generate Report" />
         
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
      <Information></Information>
     
        <Identification typeAnita={location.state.typeAnita}></Identification>
      </TabPanel>
      <TabPanel value={value} index={1}>
      <Header type={"client"} title={"Charts"}  />
      <Information></Information> 
      
        <Charts descriptionCourbe={descriptionCourbe} setDescriptionCourbe={setDescriptionCourbe} chartCalledFrom={"0"} typeAnita={location.state.typeAnita} imgSource={imgSource} setImgSource={setImgSource}  urlCaptureImage={location.state.urlCaptureImage} mesTemperatures={location.state.tabTemp}></Charts>

      </TabPanel>
      <TabPanel value={value} index={2}>
      <Header type={"client"} title={"Tables"}  />
      <Information ></Information>
       <RepairsDetailed mesTemperatures={location.state.tabTemp} typeAnita={location.state.typeAnita} uuid={uuid}></RepairsDetailed>
      </TabPanel>

      <TabPanel value={value} index={3}>
      <Header type={"client"} title={"Events"}  />
      <Information></Information>
      <TableGenerator title={"Events"} data={listEvents} setData={setListEvents} typeTable={2}></TableGenerator>
      </TabPanel>
      
      <TabPanel value={value} index={4}>
      <Header type={"client"} title={"Vacuum bagging layer configuration"}  />
      <Information></Information><br/>
        <Schema setOptions={setOptionsVacuumDiagram} options={optionsVacuumDiagram} remarks={remarks} setRemarks={setRemarks} setEntete={setEntete} entete={entete} numberplies={numberplies} setNumberplies={setNumberplies} angles={angles} setAngles={setAngles} open={open}  dialogValue={dialogValue} setDialogValue={setDialogValue} toggleOpen={toggleOpen} handleClose={handleClose} remarksAuto={remarksAuto} setRemarksAuto={setRemarksAuto}  calculatedangles={calculatedangles} setCalculatedangles={setCalculatedangles} description={description} setDescription={setDescription} activeCircle={activeCircle} setActiveCircle={setActiveCircle} activeDesc={activeDesc} setActiveDesc={setActiveDesc} information={information} comm={comm} setComm={setComm}  myimagelist={vacuumImage} setMyimagelist={setVacuumImage}></Schema>
        
      </TabPanel>
      <TabPanel value={value} index={5}>
      <Header type={"client"} title={"Additionnal elements"}  />
      <Information></Information><br/>
      <TableGenerator title={"Thermocouples used"} data={tapisThermocouple} setData={setTapisThermocouple} typeTable={0}></TableGenerator><br/>
      <TableGenerator title={"Blanket used"} data={matUsed} setData={setMatUsed} typeTable={0}></TableGenerator><br/> 
      <TableGenerator title={"Additionnal elements "} data={additionalElements} setData={setAdditionalElements} typeTable={0}></TableGenerator><br/>
      <ImageUploader myimagelist={additionalElementsPictures} setMyimagelist={setAdditionalElementsPictures} ></ImageUploader>
      </TabPanel>
      <TabPanel value={value} index={6}>
      <Header type={"client"} title={"Annex"}  />
      <Information></Information><br/>
       <ImageUploader myimagelist={myimagelist} setMyimagelist={setMyimagelist} ></ImageUploader>
  <br/>
       {/*<PdfReader></PdfReader>*/}
      </TabPanel>
      <TabPanel value={value} index={7}>
      <Header type={"client"} title={"Generate report"}  />
     
        <GeneratedReport descriptionCourbe={descriptionCourbe} listEvents={listEvents} mesTemperatures={location.state.tabTemp} setImgSource={setImgSource}  typeAnita={location.state.typeAnita} imgSource={imgSource} matUsed={matUsed} additionalElements={additionalElements}  urlCaptureImage={location.state.urlCaptureImage} remarks={remarks} setRemarks={setRemarks} setEntete={setEntete} entete={entete} numberplies={numberplies} setNumberplies={setNumberplies} angles={angles} setAngles={setAngles} open={open}  dialogValue={dialogValue} setDialogValue={setDialogValue} toggleOpen={toggleOpen} handleClose={handleClose} remarksAuto={remarksAuto} calculatedangles={calculatedangles} setCalculatedangles={setCalculatedangles} description={description} setDescription={setDescription} activeCircle={activeCircle} setActiveCircle={setActiveCircle} activeDesc={activeDesc} setActiveDesc={setActiveDesc} comm={comm} information={information} myimagelist={myimagelist} themoImages={themoImages} vacuumImage={vacuumImage} tapisThermocouple={tapisThermocouple}  additionalElementsPictures={additionalElementsPictures}  ></GeneratedReport>
      </TabPanel>
    


     <br/>
      <Footer type="main" />
      </Fragment>
  )
}

export default TabsDivider;
